import { useAverageVisitsPerSession } from '@va/dashboard/api-client/visitor-stats';
import { useSessionMetricsFilters } from '@va/dashboard/shared/filters';
import { useTranslate } from '@va/localization';
import { FiltersContextProvider } from '@va/shared/feature-filters';
import { TimePeriod } from '@va/types/time';
import { DateComparisonPeriod } from '@va/ui/components/report-block';
import { useCurrentVisitorStatsParams, usePreviousVisitorStatsParams } from '../expandable-rb/useVisitorStatsParams';
import { VisitorStatsReport } from '../expandable-rb/VisitorStatsReport';

const useCurrent = (unit: TimePeriod = TimePeriod.day) => {
  const params = useCurrentVisitorStatsParams();
  return useAverageVisitsPerSession({ ...params, unit });
};
const usePrevious = (activeComparisonOption: DateComparisonPeriod, unit: TimePeriod = TimePeriod.day) => {
  const params = usePreviousVisitorStatsParams(activeComparisonOption);
  return useAverageVisitsPerSession({ ...params, unit });
};

const AveragePagesPerSessionCard = ({
  id,
  gridPosition,
  canExpand,
}: {
  id: string;
  gridPosition: number;
  canExpand?: boolean;
}) => {
  const translate = useTranslate();
  const { allFilters } = useSessionMetricsFilters();

  return (
    <FiltersContextProvider allFilterOptions={allFilters} reportBlockId={id}>
      <VisitorStatsReport
        id={id}
        gridPosition={gridPosition}
        canExpand={canExpand}
        fetchCurrentHook={useCurrent}
        fetchPreviousHook={usePrevious}
        title={translate('latestVisitorsOverview.chart.pagesPerSession.title')}
        titleTooltip={translate('latestVisitorsOverview.axisTimeFrame.pagesPerSession.tooltip')}
        showTimePeriodFilter
      />
    </FiltersContextProvider>
  );
};

export default AveragePagesPerSessionCard;
